/* eslint-disable max-len */
import React from "react";
import { ReactFlowProvider } from "reactflow";
import { BrowserRouter } from "react-router-dom";
import { ModalRoute } from "seed/helpers"
import l from "components/util/l";
import Forms from "components/vmisc/apps/forms/Forms";
import Controller from "components/studio/Controller";
import FlowFormEdit from "components/presentation/forms/flows/FlowFormEdit";
import NodeFormCreate from "components/studio/board/node_form/NodeFormCreate";
import NodeFormEdit from "components/studio/board/node_form/NodeFormEdit";
import AnnotationFormEdit from "components/studio/board/node_form/AnnotationFormEdit";
import PageFormCreate from "components/studio/forms/pages/PageFormCreate";
import PageFormEdit from "components/studio/forms/pages/PageFormEdit";
import ProcessFormEdit from "components/studio/forms/process_form/ProcessFormEdit";
import SetupApp from "components/studio/toolbox/actions/apps/setup/SetupApp";
import Collaboration from "components/presentation/forms/collaboration/Collaboration";
import ChatNotifications from "components/presentation/chat/ChatNotifications";
import CopyClipboardButton from "components/util/helpers/CopyClipboardButton";
import Ideas from "components/studio/toolbox/ideas/Ideas"
import IdeasReport from "components/studio/toolbox/ideas/IdeasReport";
import RegisterMarquee from "components/vmisc/onboarding/RegisterMarquee";
import StyleColor from "components/util/helpers/StyleColor";
import "styles/css/studio/Studio.css";



const StudioView = ({
  flow,
  pages,
  user,
  nodes,
  edges,
  annotations,
  actions,
  activePageId,
  flowHistory,
  flowHistoryPosition,
  isOwner,
  isEditor,
  isValidator,
  isAnonymous,
  isDeveloper,
  execModeRef,
  controllerRef,
  setActivePageId,
  setHistoryPosition,
  reloadFlow,
  onPostSave,
  updateHistory,
  onClickCloseModalController
}) => (
  <>
    {user?.isAnonymous == true && <RegisterMarquee />}
    <div className="content container-fluid p-0">
      <div className="d-flex justify-content-center w-100 h-100">
        <ReactFlowProvider>
          <BrowserRouter basename={`/app/studio/${flow.id}`}>
            <StyleColor theme={flow.theme} backgroundHeight="0" />
            <Controller
              ref={controllerRef}
              execModeRef={execModeRef}
              flow={flow}
              pages={pages}
              user={user}
              activePageId={activePageId}
              initialNodes={[...nodes, ...annotations]}
              initialEdges={edges}
              actions={actions}
              flowHistory={flowHistory}
              flowHistoryPosition={flowHistoryPosition}
              isOwner={isOwner}
              isEditor={isEditor}
              isValidator={isValidator}
              isAnonymous={isAnonymous}
              setActivePageId={setActivePageId}
              setHistoryPosition={setHistoryPosition}
              reloadFlow={reloadFlow}
              onPostSave={onPostSave}
              updateHistory={updateHistory}
            />
            <ModalRoute
              width="600"
              height="800"
              path="/flow/suggestions"
              flowId={flow.id}
              pageId={activePageId}
              reloadFlow={reloadFlow}
              component={() => <div className="card"><Ideas /></div>}
            />

            <ModalRoute
              width="1200"
              height="800"
              path="/flow/suggestions/report"
              isDeveloper={isDeveloper}
              component={IdeasReport}
            />

            {isOwner ?
              <ModalRoute
                width="450"
                height="500"
                path="/flow/edit_flow"
                component={() =>
                  <FlowFormEdit
                    match={{ params: { "flowId": flow.id } }}
                  />
                }
              /> : null}

            <ModalRoute
              width="500"
              height="400"
              path="/flow/create_page"
              onClose={onClickCloseModalController}
              component={() => <PageFormCreate match={{ params: { "flowId": flow.id } }} />}
            />

            <ModalRoute
              width="500"
              height="400"
              path="/flow/edit_page/:pageId"
              onClose={onClickCloseModalController}
              component={(props) => <PageFormEdit match={{ params: { ...props.match?.params, "flowId": flow.id } }} />}
            />


            <ModalRoute
              width={600}
              height={window.innerHeight - 150}
              animation={""}
              path="/flow/process/:nodeId"
              onClose={onClickCloseModalController}
              component={(props) =>
                <ProcessFormEdit
                  nodeId={props?.match?.params?.nodeId}
                  flowId={flow.id}
                  onCompletedDelete={controllerRef.current?.onDeleteTreeNode}
                  onCompletedSubmit={controllerRef.current?.onEditTreeNode}
                />
              }
            />

            <ModalRoute
              width={800}
              height={window.innerHeight - 150}
              animation={""}
              path="/flow/create/:actionId"
              onClose={onClickCloseModalController}
              closeOnEsc={false}
              component={(props) =>
                <NodeFormCreate
                  match={props.match}
                  flowId={flow.id}
                  activePageId={activePageId}
                  onSubmit={controllerRef.current?.createNode}
                />
              }
            />

            <ModalRoute
              width={800}
              height={window.innerHeight - 150}
              animation={""}
              path="/flow/edit/:nodeId"
              onClose={onClickCloseModalController}
              closeOnEsc={false}
              component={(props) =>
                <NodeFormEdit
                  match={props.match}
                  flowId={flow.id}
                  activePageId={activePageId}
                  onLoadComponent={() => controllerRef.current?.centerNodeOnBoard(props.match?.params?.nodeId)}
                  onSubmit={controllerRef.current?.onClickEditNode}
                />
              }
            />

            <ModalRoute
              width={800}
              height={window.innerHeight - 150}
              animation={""}
              path="/flow/create_annotation/:actionId"
              onClose={onClickCloseModalController}
              closeOnEsc={false}
              component={(props) =>
                <NodeFormCreate
                  match={props.match}
                  flowId={flow.id}
                  activePageId={activePageId}
                  onSubmit={controllerRef.current?.createAnnotation}
                />
              }
            />

            <ModalRoute
              width={800}
              height={window.innerHeight - 150}
              animation={""}
              path="/flow/edit_annotation/:annotationId"
              onClose={onClickCloseModalController}
              closeOnEsc={false}
              component={(props) =>
                <AnnotationFormEdit
                  match={props.match}
                  flowId={flow.id}
                  activePageId={activePageId}
                  onSubmit={controllerRef.current?.onClickEditAnnotation}
                />
              }
            />

            <ModalRoute
              width={600}
              height={window.innerHeight - 150}
              animation={""}
              path="/flow/setup/:appId"
              component={(props) =>
                <SetupApp
                  match={props.match}
                  flowId={flow.id} />}
            />

            <ModalRoute
              width={850}
              height={600}
              animation={""}
              path="/flow/share"
              component={() => <Collaboration flowId={flow.id} />}
            />

            <ModalRoute
              width={750}
              height={window.innerHeight - 150}
              animation={""}
              path="/flow/website/:url"
              component={({ match }) => <div className="card w-100 h-100">
                <div className="w-100 text-center py-2">{l("Liga para compartir%SA001")}:&nbsp;
                  <a href={decodeURIComponent(match.params?.url)} target="_blank" rel="noreferrer">{decodeURIComponent(match.params?.url)}</a>
                  <CopyClipboardButton link={decodeURIComponent(match.params?.url)} />
                </div>
                <iframe className="w-100 h-100"
                  src={decodeURIComponent(match.params?.url + (match.params?.url.includes("?") ? "&" : "?") + "is_debug=true")}
                  referrerpolicy="same-origin" title="website" />
              </div>}
            />

            <ChatNotifications flow={flow} />

          </BrowserRouter>
        </ReactFlowProvider>
        <Forms flow={flow} />
      </div>
    </div>
  </>
);

export default StudioView;